import { jwtDecode } from 'jwt-decode';

function payloadIsValid(payload) {
  return payload.exp * 1000 > new Date().getTime();
}

function validateUser(user) {
  const { username, token } = user;

  if (!username || !token) {
    return false;
  }

  return true;
}

export default validateUser;
